var exports = {
  "kL": "BaseAvatar.module__container___UTQ0Y1",
  "vk": "BaseAvatar.module__clickable___UTQ0Y1",
  "Lw": "BaseAvatar.module__overlay___UTQ0Y1",
  "Sl": "BaseAvatar.module__image___UTQ0Y1",
  "qf": "BaseAvatar.module__placeholder___UTQ0Y1",
  "ci": "BaseAvatar.module__placeholderFastFade___UTQ0Y1",
  "Ap": "BaseAvatar.module__placeholderVisible___UTQ0Y1",
  "uR": "BaseAvatar.module__placeholderHidden___UTQ0Y1",
  "n_": "BaseAvatar.module__hoverOverlay___UTQ0Y1",
  "II": "BaseAvatar.module__statusContainer___UTQ0Y1",
  "mH": "BaseAvatar.module__statusTooltipDisabled___UTQ0Y1",
  "VN": "BaseAvatar.module__reducedMotion___UTQ0Y1",
  "BC": "BaseAvatar.module__animatedMaskShape___UTQ0Y1",
  "Qb": "BaseAvatar.module__animatedMaskReducedMotion___UTQ0Y1",
  "AP": "BaseAvatar.module__typingBubble___UTQ0Y1",
  "y5": "BaseAvatar.module__typingDots___UTQ0Y1",
  "BI": "BaseAvatar.module__typingDot___UTQ0Y1",
  "Zm": "BaseAvatar.module__blink___UTQ0Y1",
  "fQ": "BaseAvatar.module__customStatusBadge___UTQ0Y1",
  "Bp": "BaseAvatar.module__customStatusBadgeBackground___UTQ0Y1",
  "Go": "BaseAvatar.module__customStatusBadgeContent___UTQ0Y1",
};

module.exports = exports;
